import {aiPromptBoxActions} from '@Components/ai-prompt-box/ai-prompt-box.reducer';

/**
 * Pre-fills set for boxes whose Redux entity doesn't exist yet (panel never mounted). `useAiPromptBox`
 * consumes the entry when it initializes that box, so the pre-fill lands without clobbering the panel's
 * initialConfig. Cleared by the surface that set them when it unmounts (stale pre-fills must not leak
 * into unrelated later opens, e.g. the left-toolbar AI panels).
 */
const pendingPreFills = new Map<string, string>();

/**
 * Pre-fills a prompt box with text (e.g. the active stock search term) without triggering any generation.
 * A box the user already typed into is left alone — only an empty box, or one still holding a previous
 * pre-fill, is overwritten.
 */
export const preFillAiPromptBox = (id: string, prompt: string): void => {
  const trimmedPrompt = prompt.trim();
  if (trimmedPrompt === '') {
    return;
  }

  const doesBoxExist = window.PMW.redux.store.getState().aiPromptBox[id] !== undefined;
  if (doesBoxExist) {
    window.PMW.redux.store.dispatch(aiPromptBoxActions.preFillPromptIfUntouched({id, prompt: trimmedPrompt}));
    return;
  }
  pendingPreFills.set(id, trimmedPrompt);
};

export const consumePendingAiPromptBoxPreFill = (id: string): string | undefined => {
  const preFill = pendingPreFills.get(id);
  pendingPreFills.delete(id);
  return preFill;
};

export const clearPendingAiPromptBoxPreFills = (): void => {
  pendingPreFills.clear();
};
